import { PromotionService } from '@/services/promotion.service'
import { TrainingService } from '@/services/training.service'
import { HTTP_STATUS_CODES } from '@/configs/constants.ts'
import { commitPaginationFromMeta, showErrorToast } from './helpers'

export const promotionActions = {
  async loadPromoFilters({ commit }) {
    const response = await PromotionService.resultFilters()
    commit('SET_PROMO_FILTERS', response.data)
  },

  async loadTrainingFilters({ commit }) {
    const response = await TrainingService.resultFilters()
    const payload = response?.data?.data ?? response?.data ?? {}
    const trainings = Array.isArray(payload?.trainings)
      ? payload.trainings
      : Object.entries(payload?.trainings ?? {}).map(([value, label]) => ({
          value: Number.isNaN(Number(value)) ? value : Number(value),
          label: typeof label === 'string' ? label : Object.values(label ?? {})[0] ?? '',
        }))

    commit('SET_TRAINING_FILTERS', {
      ...payload,
      users: Array.isArray(payload?.users) ? payload.users : [],
      trainings,
    })
  },

  async loadSalesPromotions({ commit }, data) {
    try {
      const response = await PromotionService.getSalesPromotions(data)
      if (response.status == HTTP_STATUS_CODES.OK) {
        commit('SET_SALES_PROMOTIONS', response.data.data)
        commitPaginationFromMeta(commit, response)
      }
    } catch (e) {
      showErrorToast(e)
      console.error(e)
    }
  },

  async loadPromotions({ commit }, page = 1) {
    const response = await PromotionService.getList(page)

    commit('SET_PROMOTION_LIST', response.data.data)
    commitPaginationFromMeta(commit, response)
  },

  async loadPromotionById({ commit }, id) {
    const response = await PromotionService.promotion(id)

    commit('SET_PROMOTION', response.data.data)
  }
}
